import styled from 'styled-components'

export const SizeContainer = styled.div`
  position: absolute;

  width: ${props => props.w}px;
  height: ${props => props.h}px;

  box-shadow: 0 4px 8px black;
`



// WEBPACK FOOTER //
// ./src/components/DraggableProduct/theme.js